import styles from './ErrorFallback.module.scss'

interface ErrorFallbackProps {
  resetError?: () => void
}

// user-facing error fallback component
export default function ErrorFallback({ resetError }: ErrorFallbackProps) {
  const handleReset = () => {
    if (resetError) {
      resetError()
    } else {
      window.location.reload()
    }
  }

  return (
    <div className={styles.container}>
      <p className={styles.title}>Something went wrong</p>
      <p className={styles.description}>Please try refreshing the page. If the problem persists, contact support.</p>
      <button className={styles.button} onClick={handleReset}>
        Refresh
      </button>
    </div>
  )
}
